import { Component } from '@angular/core';



@Component({
  selector: 'app-no-permission-error',
  templateUrl: './no-permission-error.component.html',
  host: {
    'class': 'd-flex flex-column flex-fill align-items-center justify-content-center w-100'
  }
})
export class NoPermissionErrorComponent {
}
